import { ModalsService } from '@ace/core';

export const modalService = ModalsService.getInstance(true);
